import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16.003 8.998h-9a.75.75 0 100 1.5h9a.75.75 0 100-1.5zM16.754 13.248a.76.76 0 00-.75-.75H7.001a.75.75 0 000 1.5h9.002a.76.76 0 00.75-.75zM9.5 6.497h4a1 1 0 001-1v-2.5a3 3 0 10-6 .09v2.41a1 1 0 001 1zm1.25-3.75a.75.75 0 11.75.75.76.76 0 01-.75-.75z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.003 2.996h-2.75a.25.25 0 00-.25.25v1.5a.25.25 0 00.25.25h2.25a.5.5 0 01.5.5V18.29a.51.51 0 01-.15.36l-3.2 3.2a.491.491 0 01-.36.15H4.5a.5.5 0 01-.5-.5V5.497a.5.5 0 01.5-.5h2.25a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H4a2 2 0 00-2 2v17.002a2 2 0 002 2h15.003a2 2 0 002-2V4.996a2 2 0 00-2-2z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M7.002 15.998a.75.75 0 000 1.5h3.75a.75.75 0 100-1.5h-3.75z",
      fill: "#333"
    }
  )
), l = t;
export {
  l as default
};
